import React from "react";
import AssessmentCard from "./assessment-card";
import Growbot from "../growbot/growbot";
import { IAssessment } from "../types";

interface IAssessmentsListProps {
  assessmentData: IAssessment[];
  viewType: string;
}

function AssessmentList({ assessmentData, viewType }: IAssessmentsListProps) {
  return (
    <>
      <Growbot botstyle="flower" className="left" />
      {/* <aside className="left-section" aria-label="Side Image"></aside> */}
      <main className="right-section" aria-label="Cards Section">
        <div className="card-cell">
          {assessmentData.map((card) => (
            <AssessmentCard key={card.id} viewType={viewType} {...card} />
          ))}
        </div>
      </main>
    </>
  );
}

export default AssessmentList;
